import { useState } from 'react';
import useBreakpoints from '@hooks/useBreakpoints';
import useLayoutEffect from './useLayoutEffect';

// Calculates right offset from a nav flyout to the right side of the page to align with right edge of profile flyout
const useNavFlyoutPlacement = (iconRecRight: number, isFlyoutVisible: boolean): number => {
  const { widthWindow } = useBreakpoints();
  const [scrollBarWidth, setScrollBarWidth] = useState(0);
  useLayoutEffect(() => {
    const clientWidth = typeof document !== 'undefined' ? document.documentElement?.clientWidth : 0;
    if (clientWidth && !isFlyoutVisible) {
      setScrollBarWidth(widthWindow - clientWidth);
    }
  }, [isFlyoutVisible, widthWindow]);
  return widthWindow - 24 - scrollBarWidth - iconRecRight;
};

export default useNavFlyoutPlacement;
